<template>
  <div v-if="!params.hide" class="toggle">
    <q-tooltip v-if="params.disable">{{ params.disableText || 'Cannot be modified' }}</q-tooltip>
    <q-toggle data-cy="toggle" :disable="params.disable" :value="value" @input="onToggle" />
  </div>
</template>

<script>
import Vue from 'vue'
import store from '@/store'

export default Vue.extend({
  name: 'AgGridToggle',
  store,
  computed: {
    value() {
      if (!this.params.data) return
      if (this.params.getFromValue) return this.params.value.val
      return this.params.val
    }
  },
  methods: {
    onToggle(val) {
      if (this.params.handleToggleOnParent) this.params.handleToggleOnParent(val)
      else if (this.params.getFromValue) this.params.value.onUpdate(val, this.params.value.key, this.params.data.id)
      else this.params.onUpdate(val, this.params.key, this.params.data.id)
    },
    refresh(params) {
      if (this.params.val !== params.val || params.getFromValue) {
        this.params = params
      }
      return true
    }
  }
})
</script>
